import React, {FunctionComponent, useState, useEffect} from 'react';
import './style.less'
import {Input,Row,Col,Typography,List,Button} from 'antd';
import { HomeResources } from '../../resources';
import { useParams } from 'react-router-dom'
import { useStore } from "../../store";
import { MdAddShoppingCart } from 'react-icons/md';

const { Title } = Typography;
const { Search } = Input;

interface SearchDomainProps{}

const SearchDomain: FunctionComponent<SearchDomainProps> = () =>
{
    const { dispatch } = useStore();
    const [search, setSearch] = useState<string>('');
    const handleSearch = (value: string) => { };
    const params:{name:string} = useParams()

    useEffect(() => setSearch(params.name) , [params.name])

    return (
        <div className="SearchDomain" >
            <div
                className="page-head-background"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/images/background.svg'})`
                }}
            >
                <Row style={{
                    margin: "0 auto",
                    width: "80%",
                    paddingTop:'130px'
                }} >
                <Col span={24}>
                    <Title className="text-center" >{SEARCH_TITLE_SEARCH_PAGE}</Title>
                </Col>
                <Col span={24}>
                    <Search
                        size="large"
                        placeholder={SEARCH_PLACEHOLDER}
                        onSearch={handleSearch}
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                        enterButton
                    />
                </Col>
                </Row>
            </div><br/><br/>
            <List
                size="large"
                className="demo-loadmore-list"
                style={{maxWidth:"800px", margin:"0 auto"}}
                // loading={initLoading}
                itemLayout="horizontal"
                dataSource={DOMAIN_LIST}
                renderItem={item => (
                <List.Item
                    actions={window.innerWidth < 500 ?[<Button style={{marginLeft:10}} onClick={()=>dispatch({type: "ADD_TO_CART", payload: {...item, title:search+item.title.toLocaleLowerCase()}})}><MdAddShoppingCart size="20px"/></Button>]:[<Button onClick={()=>dispatch({type: "ADD_TO_CART", payload:{ ...item, title:search+item.title.toLocaleLowerCase()}})}>Add to cart</Button>]}
                >
                <List.Item.Meta title={ search.toLocaleLowerCase()+item.title.toLocaleLowerCase() }/>
                <h3 style={{fontWeight:"bold"}}>{PRICE_TEMPLATE(item.dPrice)}</h3>
                </List.Item>
                )}
            />
        </div>
    );
}

export default SearchDomain;

const {SEARCH_TITLE_SEARCH_PAGE, SEARCH_PLACEHOLDER, DOMAIN_LIST, PRICE_TEMPLATE } = HomeResources;